__turbopack_context__.v({
  "actions": "Navigation-module__lf4dqG__actions",
  "backgroundStyle": "Navigation-module__lf4dqG__backgroundStyle",
  "bookCallButton": "Navigation-module__lf4dqG__bookCallButton",
  "brand": "Navigation-module__lf4dqG__brand",
  "brandLogo": "Navigation-module__lf4dqG__brandLogo",
  "brandLogoAnimated": "Navigation-module__lf4dqG__brandLogoAnimated",
  "darkMode": "Navigation-module__lf4dqG__darkMode",
  "doAnimation": "Navigation-module__lf4dqG__doAnimation",
  "langActive": "Navigation-module__lf4dqG__langActive",
  "langSwitch": "Navigation-module__lf4dqG__langSwitch",
  "logo-bracket-lower": "Navigation-module__lf4dqG__logo-bracket-lower",
  "logo-bracket-upper": "Navigation-module__lf4dqG__logo-bracket-upper",
  "logo-diamond-fly": "Navigation-module__lf4dqG__logo-diamond-fly",
  "logo-morph-in": "Navigation-module__lf4dqG__logo-morph-in",
  "logo-wordmark-unfold": "Navigation-module__lf4dqG__logo-wordmark-unfold",
  "logoBracketLower": "Navigation-module__lf4dqG__logoBracketLower",
  "logoBracketUpper": "Navigation-module__lf4dqG__logoBracketUpper",
  "logoDiamond": "Navigation-module__lf4dqG__logoDiamond",
  "logoMorph": "Navigation-module__lf4dqG__logoMorph",
  "logoWordmark": "Navigation-module__lf4dqG__logoWordmark",
  "mobileBookCall": "Navigation-module__lf4dqG__mobileBookCall",
  "mobileMenuIcon": "Navigation-module__lf4dqG__mobileMenuIcon",
  "nav-in": "Navigation-module__lf4dqG__nav-in",
  "navInner": "Navigation-module__lf4dqG__navInner",
  "navbar": "Navigation-module__lf4dqG__navbar",
  "navigationItem": "Navigation-module__lf4dqG__navigationItem",
  "navigationList": "Navigation-module__lf4dqG__navigationList",
  "scrollButton": "Navigation-module__lf4dqG__scrollButton",
  "show": "Navigation-module__lf4dqG__show",
});
